import React from "react"
import { SelectSeeker } from "@ui-seeker/core"


const INCLUDE_OPTIONS = { label: 'Include', value: 'include' }
const EXCLUDE_OPTIONS = { label: 'Exclude', value: 'exclude' }

export default function AppIncExSelect({ value, onChange, ...props }) {
	return <SelectSeeker
		label=""
		isClearable={false}
		value={value ? INCLUDE_OPTIONS.value : EXCLUDE_OPTIONS.value}
		onChange={e => onChange({
			target: { value: e.target.value === INCLUDE_OPTIONS.value }
		})}
		options={[INCLUDE_OPTIONS, EXCLUDE_OPTIONS]}
		{...props}
	/>
}